module.exports = __webpack_public_path__ + "img/img_header_pagosonline.510ebab4.jpg";